import { createSelector, createStructuredSelector } from 'reselect';
import _ from 'lodash';

export const userSelector = (state) => state.user;

export const isUserLoggedInSelector = createSelector(userSelector, (user) =>
  _.get(user, 'isLogin', false)
);

export const getIsUserLoading = (state) => state.user.isLoading;

export const userIdSelector = createSelector(userSelector, (user) =>
  _.get(user, 'info.user_id', 0)
);

export const getUserHistory = (state) => {
  const id = _.get(state, 'app.id');
  return state.user.history[id] || {};
};

export default createStructuredSelector({
  userSelector,
  isUserLoggedInSelector,
  userIdSelector,
  getUserHistory,
  getIsUserLoading,
});
